import React, { Component } from "react";
import DashboardWidgetContainer from "../../../containers/DashboardWidget/DashboardWidgetContainer";
import withStyles from "@mui/styles/withStyles";
import { FacebookProvider, Page } from "react-facebook";
import { TwitterTimelineEmbed } from "react-twitter-embed";
import InstagramEmbed from "react-instagram-embed";
import CustomizeModal from "./CustomizeModal";
import { capitalize } from "../../../utils/string";
import { widgetKeys } from "../../../constants";
import { withTranslation } from "react-i18next";

const styles = theme => ({
  container: {
    minWidth: "100%",
    minHeight: 500,
    display: "flex",
    justifyContent: "center"
  }
});

class SocialEmbed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      pageWidth: 384,
      modalOpen: false
    };
    this.fbContainerRef = React.createRef();
  }

  updateDimensions() {
    if (this.fbContainerRef && this.fbContainerRef.current) {
      this.setState({ pageWidth: this.fbContainerRef.current.offsetWidth });
    }
  }

  componentDidMount() {
    this.updateDimensions();
    window.addEventListener("resize", this.updateDimensions.bind(this));
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateDimensions.bind(this));
  }

  componentDidUpdate() {
    if (
      this.fbContainerRef &&
      this.fbContainerRef.current &&
      this.state.pageWidth !== this.fbContainerRef.current.offsetWidth
    ) {
      this.setState({ pageWidth: this.fbContainerRef.current.offsetWidth });
    }
  }

  handleMenuItemClick = item => {
    if (item.value === "customize") {
      this.setState({
        modalOpen: true
      });
    }
  };

  handleModalClose = () => {
    this.setState({
      modalOpen: false
    });
  };

  handleSaveOptions = context => {
    this.props.updateCustomer({
      url: context.url,
      platform: context.option
    });
  };

  renderFacebook() {
    const { pageWidth } = this.state;
    const { currentCustomer } = this.props;
    if (currentCustomer.socialPlatform === "facebook") {
      return (
        <FacebookProvider appId={process.env.REACT_APP_FACEBOOK_APP_ID}>
          <Page
            href={currentCustomer.socialUrl}
            tabs="timeline"
            height="500px"
            width={pageWidth}
          />
        </FacebookProvider>
      );
    }
  }

  renderTwitter() {
    const { pageWidth } = this.state;
    const { currentCustomer } = this.props;
    if (currentCustomer.socialPlatform === "twitter") {
      return (
        <TwitterTimelineEmbed
          sourceType="profile"
          url={currentCustomer.socialUrl}
          options={{ height: 500, width: pageWidth }}
        />
      );
    }
  }

  renderInstagram() {
    const { currentCustomer } = this.props;
    if (currentCustomer.socialPlatform === "instagram") {
      return <InstagramEmbed url={currentCustomer.socialUrl} />;
    }
  }

  renderMenuOptions(currentUser, t) {
    if (
      currentUser.isAdmin &&
      !(currentUser.permissions.silver || currentUser.permissions.validate)
    ) {
      return [
        { value: "customize", label: t("socialEmbed.options.customize") }
      ];
    } else {
      return [];
    }
  }

  render() {
    const { classes, currentUser, currentCustomer, t, dashboard } = this.props;
    const { modalOpen } = this.state;

    return (
      <DashboardWidgetContainer
        dashboard={dashboard}
        widgetKey={widgetKeys.socialMedia}
        title={capitalize(currentCustomer.socialPlatform)}
        menuProps={{
          options: this.renderMenuOptions(currentUser, t),
          onMenuItemClick: this.handleMenuItemClick
        }}
      >
        <div
          data-qa="dashboard-widgets-social"
          ref={this.fbContainerRef}
          className={classes.container}
        >
          {this.renderFacebook()}
          {this.renderTwitter()}
          {this.renderInstagram()}
          <CustomizeModal
            open={modalOpen}
            onClose={this.handleModalClose}
            onSave={this.handleSaveOptions}
            customOption={currentCustomer.socialPlatform}
            customUrl={currentCustomer.socialUrl}
          />
        </div>
      </DashboardWidgetContainer>
    );
  }
}

const TranslatedSocialEmbed = withTranslation()(SocialEmbed);

export default withStyles(styles)(TranslatedSocialEmbed);
